import { observer } from "mobx-react";
import * as React from "react";
import { getJobCategoryOptions } from "../../../constants";
import { t } from "../../../i18n/util";
import { API } from "../../../network/API";
import { applicationStore } from "../../../stores/ApplicationStore";
import { authStore } from "../../../stores/AuthStore";
import { generalStore } from "../../../stores/GeneralStore";
import { ApplicationValues, GermanLvlEnum } from "../../../types/models";
import { pushRoute } from "../../app/router/history";
import { useMobileMediaQuery } from "../../hooks/useMobileMediaQuery";
import { HrRoutes } from "../../hr/router/HrRoutes";
import { ContentWrapper } from "../../ui/ContentWrapper";
import { optionToString } from "../../util/helpers";
import { ApplicationRoutes } from "../router/ApplicationRoutes";
import { VerificationForm } from "../VerificationForm";

export const VerificationSite = observer(() => {
    React.useEffect(() => {
        if (!applicationStore.isStepFinished["dataUpload"]) {
            pushRoute(ApplicationRoutes.PERSONAL_DATA);
        }
    }, []);

    const handleSubmit = async (application: ApplicationValues) => {
        try {
            generalStore.isLoading = true;
            await API.postApplicant({
                ...application,
                jobCategory: application.jobCategoryId ?? "j",
                germanLvl: application.germanLvl as GermanLvlEnum,
            });
            applicationStore.isStepFinished["verification"] = true;

            if (authStore.isAuthenticated) {
                pushRoute(HrRoutes.DASHBOARD);
            } else {
                pushRoute(ApplicationRoutes.SUCCESS);
            }
        } catch (error) {
            generalStore.setError(t("error.postApplication"), error);
        } finally {
            generalStore.isLoading = false;
        }
    };

    const isMobile = useMobileMediaQuery();

    const handlePersonalData = () => pushRoute(ApplicationRoutes.PERSONAL_DATA);
    const handleDetails = () => pushRoute(ApplicationRoutes.DETAILS);
    const handleDataUpload = () => pushRoute(ApplicationRoutes.DATA_UPLOAD);
    const handleMotivation = () => pushRoute(ApplicationRoutes.MOTIVATION);

    return (
        <ContentWrapper>
            <h2
                style={
                    isMobile
                        ? {
                            fontSize: 22,
                            lineHeight: "28px",
                            margin: "0 0 32px"
                        }
                        : { marginBottom: 76 }
                }
            >
                {isMobile
                    ? t("screen.sidebar.verify")
                    : optionToString(getJobCategoryOptions(), applicationStore.currentApplication.jobCategory) || applicationStore.currentApplication.jobCategory}
            </h2>
            <VerificationForm
                onPersonalData={handlePersonalData}
                onDetails={handleDetails}
                onDataUpload={handleDataUpload}
                onMotivation={handleMotivation}
                onSubmit={handleSubmit}
            />
        </ContentWrapper>
    );
});
